import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Education from './Education';

import './index.sass';

const { block, el } = bem('educations');

const Educations = ({educations}) => {

    return (
        <div className={block()}>
            <div className={el('title')}>
                <Text serif>Образование</Text>
            </div>
            <div className={el('list')}>
                {educations.map((education, index) => <Education key={index} {...education} />)}
            </div>
        </div>
    )
};

export default Educations;
